import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const PostReactionItem = ({
  reactions,
  auth: { isAuthenticated },
  reaction,
  role,
  AddReaction,
  id,
  channelid,
  user,
}) => {
  const [reactionTargetDelight, setReactionTargetDelight] = useState({
    id: id,
    channelid: channelid,
    type: "delight",
  });
  const [reactionTargetHilarious, setReactionTargetHilarious] = useState({
    id: id,
    channelid: channelid,
    type: "hilarious",
  });
  const [reactionTargetDreamy, setReactionTargetDreamy] = useState({
    id: id,
    channelid: channelid,
    type: "dreamy",
  });
  const [reactionTargetYikes, setReactionTargetYikes] = useState({
    id: id,
    channelid: channelid,
    type: "yikes",
  });
  const [reactionTargetEyeRoll, setReactionTargetEyeRoll] = useState({
    id: id,
    channelid: channelid,
    type: "eyeRoll",
  });
  const [reactionTargetAngry, setReactionTargetAngry] = useState({
    id: id,
    channelid: channelid,
    type: "angry",
  });
  const [showClick, setShowClick] = useState({
    Delight: false,
    Hilarious: false,
    Dreamy: false,
    Yikes: false,
    EyeRoll: false,
    Angry: false,
  });

  let foundDelight;
  let foundHilarious;
  let foundDreamy;
  let foundYikes;
  let foundEyeRoll;
  let foundAngry;

  if (reactions) {
    foundDelight = reactions.filter(
      (x) =>
        x.channelid === user.channelid &&
        x.reaction_type === "delight" &&
        x.post_id == id
    );
    foundHilarious = reactions.filter(
      (x) =>
        x.channelid === user.channelid &&
        x.reaction_type === "hilarious" &&
        x.post_id == id
    );
    foundDreamy = reactions.filter(
      (x) =>
        x.channelid === user.channelid &&
        x.reaction_type === "dreamy" &&
        x.post_id == id
    );
    foundYikes = reactions.filter(
      (x) =>
        x.channelid === user.channelid &&
        x.reaction_type === "yikes" &&
        x.post_id == id
    );
    foundEyeRoll = reactions.filter(
      (x) =>
        x.channelid === user.channelid &&
        x.reaction_type === "eyeRoll" &&
        x.post_id == id
    );
    foundAngry = reactions.filter(
      (x) =>
        x.channelid === user.channelid &&
        x.reaction_type === "angry" &&
        x.post_id == id
    );
  }

  return (
    <Fragment>
      <div className="reaction-container-flex">
        <div
          className="reaction-count"
          onClick={() => {
            if (isAuthenticated) {
              setReactionTargetDelight({
                ...reactionTargetDelight,
              });
              AddReaction(id, "roland", reactionTargetDelight.type);
            }
          }}
          onMouseOver={() =>
            setShowClick({
              Delight: true,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
          onMouseLeave={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
        >
          {reactions &&
            reactions.length > 0 &&
            reactions.filter((x) => {
              return x.post_id == id && x.reaction_type === "delight";
            }).length > 0 &&
            reactions.map((emoji) => {
              if (
                emoji.channelid === user.channelid &&
                emoji.reaction_type === "delight" &&
                emoji.post_id == id
              ) {
                return (
                  <i
                    className={`fa-solid fa-face-smile-beam fa-lg mx-5 ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                );
              }
            })}
          {foundDelight && foundDelight.length <= 0 && (
            <i
              className={`fa-regular fa-face-smile-beam fa-lg mx-5 ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              }`}
            ></i>
          )}
          <span className="count white">
            {reactions &&
              reactions.filter((x) => {
                if (x.post_id == id && x.reaction_type === "delight") return x;
              }).length}
          </span>
          <p className="emoji-type white">Delight</p>
          {showClick.Delight && <p className="double-click white">Click 1x</p>}
        </div>
        <div
          className="reaction-count"
          onClick={() => {
            if (isAuthenticated) {
              setReactionTargetHilarious({
                ...reactionTargetHilarious,
              });
              AddReaction(id, "roland", reactionTargetHilarious.type);
            }
          }}
          onMouseOver={() =>
            setShowClick({
              Delight: false,
              Hilarious: true,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
          onMouseLeave={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
        >
          {reactions &&
            reactions.length > 0 &&
            reactions.filter((x) => {
              return x.post_id == id && x.reaction_type === "hilarious";
            }).length > 0 &&
            reactions.map((emoji) => {
              if (
                emoji.channelid === user.channelid &&
                emoji.reaction_type === "hilarious" &&
                emoji.post_id == id
              ) {
                return (
                  <i
                    className={`fa-solid fa-face-grin-squint-tears fa-lg mx-5 ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                );
              }
            })}
          {foundHilarious && foundHilarious.length <= 0 && (
            <i
              className={`fa-regular fa-face-grin-squint-tears fa-lg mx-5 ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              }`}
            ></i>
          )}
          <span className="count white">
            {reactions &&
              reactions.filter((x) => {
                if (x.post_id == id && x.reaction_type === "hilarious")
                  return x;
              }).length}
          </span>
          <p className="emoji-type white">Hilarious</p>
          {showClick.Hilarious && (
            <p className="double-click white">Click 1x</p>
          )}
        </div>
        <div
          className="reaction-count"
          onClick={() => {
            if (isAuthenticated) {
              setReactionTargetDreamy({
                ...reactionTargetDreamy,
              });
              AddReaction(id, "roland", reactionTargetDreamy.type);
            }
          }}
          onMouseOver={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: true,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
          onMouseLeave={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
        >
          {reactions &&
            reactions.length > 0 &&
            reactions.filter((x) => {
              return x.post_id == id && x.reaction_type === "dreamy";
            }).length > 0 &&
            reactions.map((emoji) => {
              if (
                emoji.channelid === user.channelid &&
                emoji.reaction_type === "dreamy" &&
                emoji.post_id == id
              ) {
                return (
                  <i
                    className={`fa-solid fa-face-grin-hearts fa-lg mx-5 ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                );
              }
            })}
          {foundDreamy && foundDreamy.length <= 0 && (
            <i
              className={`fa-regular fa-face-grin-hearts fa-lg mx-5 ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              }`}
            ></i>
          )}
          <span className="count white">
            {reactions &&
              reactions.filter((x) => {
                if (x.post_id == id && x.reaction_type === "dreamy") return x;
              }).length}
          </span>
          <p className="emoji-type white">Dreamy</p>
          {showClick.Dreamy && <p className="double-click white">Click 1x</p>}
        </div>
        <div
          className="reaction-count"
          onClick={() => {
            if (isAuthenticated) {
              setReactionTargetYikes({
                ...reactionTargetYikes,
              });
              AddReaction(id, "roland", reactionTargetYikes.type);
            }
          }}
          onMouseOver={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: true,
              EyeRoll: false,
              Angry: false,
            })
          }
          onMouseLeave={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
        >
          {reactions &&
            reactions.length > 0 &&
            reactions.filter((x) => {
              return x.post_id == id && x.reaction_type === "yikes";
            }).length > 0 &&
            reactions.map((emoji) => {
              if (
                emoji.channelid === user.channelid &&
                emoji.reaction_type === "yikes" &&
                emoji.post_id == id
              ) {
                return (
                  <i
                    className={`fa-solid fa-face-grimace fa-lg mx-5 ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                );
              }
            })}
          {foundYikes && foundYikes.length <= 0 && (
            <i
              className={`fa-regular fa-face-grimace fa-lg mx-5 ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              }`}
            ></i>
          )}
          <span className="count white">
            {reactions &&
              reactions.filter((x) => {
                if (x.post_id == id && x.reaction_type === "yikes") return x;
              }).length}
          </span>
          <p className="emoji-type white">Yikes</p>
          {showClick.Yikes && <p className="double-click white">Click 1x</p>}
        </div>
        <div
          className="reaction-count"
          onClick={() => {
            if (isAuthenticated) {
              setReactionTargetEyeRoll({
                ...reactionTargetEyeRoll,
              });
              AddReaction(id, "roland", reactionTargetEyeRoll.type);
            }
          }}
          onMouseOver={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: true,
              Angry: false,
            })
          }
          onMouseLeave={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
        >
          {reactions &&
            reactions.length > 0 &&
            reactions.filter((x) => {
              return x.post_id == id && x.reaction_type === "eyeRoll";
            }).length > 0 &&
            reactions.map((emoji) => {
              if (
                emoji.channelid === user.channelid &&
                emoji.reaction_type === "eyeRoll" &&
                emoji.post_id == id
              ) {
                return (
                  <i
                    className={`fa-solid fa-face-rolling-eyes fa-lg mx-5 ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                );
              }
            })}
          {foundEyeRoll && foundEyeRoll.length <= 0 && (
            <i
              className={`fa-regular fa-face-rolling-eyes fa-lg mx-5 ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              }`}
            ></i>
          )}
          <span className="count white">
            {reactions &&
              reactions.filter((x) => {
                if (x.post_id == id && x.reaction_type === "eyeRoll") return x;
              }).length}
          </span>
          <p className="emoji-type white">Eye Roll</p>
          {showClick.EyeRoll && <p className="double-click white">Click 1x</p>}
        </div>
        <div
          className="reaction-count"
          onClick={() => {
            if (isAuthenticated) {
              setReactionTargetAngry({
                ...reactionTargetAngry,
              });
              AddReaction(id, "roland", reactionTargetAngry.type);
            }
          }}
          onMouseOver={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: true,
            })
          }
          onMouseLeave={() =>
            setShowClick({
              Delight: false,
              Hilarious: false,
              Dreamy: false,
              Yikes: false,
              EyeRoll: false,
              Angry: false,
            })
          }
        >
          {reactions &&
            reactions.length > 0 &&
            reactions.filter((x) => {
              return x.post_id == id && x.reaction_type === "angry";
            }).length > 0 &&
            reactions.map((emoji) => {
              if (
                emoji.channelid === user.channelid &&
                emoji.reaction_type === "angry" &&
                emoji.post_id == id
              ) {
                return (
                  <i
                    className={`fa-solid fa-face-angry fa-lg mx-5 ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                );
              }
            })}
          {foundAngry && foundAngry.length <= 0 && (
            <i
              className={`fa-regular fa-face-angry fa-lg mx-5 ${
                role && role === "innovator"
                  ? "green"
                  : role && role === "mentor"
                  ? "red"
                  : role && role === "employer"
                  ? "blue"
                  : ""
              }`}
            ></i>
          )}
          <span className="count white">
            {reactions &&
              reactions.filter((x) => {
                if (x.post_id == id && x.reaction_type === "angry") return x;
              }).length}
          </span>
          <p className="emoji-type white">Angry</p>
          {showClick.Angry && <p className="double-click white">Click 1x</p>}
        </div>
      </div>
    </Fragment>
  );
};

PostReactionItem.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.isAuthenticated,
});

export default connect(mapStateToProps, {})(PostReactionItem);
